import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";

export default function ViewCustomer({
  show,
  closeModal,
  refreshPage,
  transfer,
}) {
  const handleClose = () => {
    closeModal();
  };

  const [transfers, setTransfer] = useState([]);

  useEffect(() => {
    if (transfer) {
      setTransfer(transfer);
    }
  }, [transfer]);

  const transferCrad = transfers && transfers ? (
    <Card className="mb-3">
      <Card.Body>
        <Card.Text>
          <strong>Originating Warehouse:</strong> {transfers.from_warehouse}
          <br />
          <strong>From Category:</strong> {transfers.from_category}
          <br />
          <strong>From Sub_category:</strong> {transfers.from_sub_category}
          <br />
          <strong>From Product:</strong> {transfers.from_product_name}
          <br />
          <strong>From Batch Number:</strong> {transfers.from_batch_number}
          <br />
        <div>
          <hr />
        </div>
          <strong>Destination Warehouse:</strong> {transfers.to_warehouse}
          <br />
          <strong>To Category:</strong> {transfers.to_category}
          <br />
          <strong>To Sub_category:</strong> {transfers.to_sub_category}
          <br />
          <strong>To product:</strong> {transfers.to_product_name}
          <br />
          <strong>To Batch Number:</strong> {transfers.to_batch_number}
          <br />
          <strong>Quantity:</strong> {transfers.quantity}
          <br />
        </Card.Text>
      </Card.Body>
    </Card>
  ) : (
    <p>No Transfer details available.</p>
  );

  return (
    <div className="ViewTransaction">
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>View Transfer Details</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "15px", lineHeight: "30px" }}>
          {transferCrad}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
          <Button
            style={{ backgroundColor: "#c4281b", border: "none" }}
            onClick={refreshPage}
          >
            Refresh
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
